export const SearchDisabledInGroup = "WP0M8";
export const GroupsSearchPlaceholder = "PfUiob";
export const SearchDisabled = "CCpsqd";
export const archiveMailboxFoldersSearchPlaceholder = "cbKKs";
export const MOSAppSearchPlaceholder = "$zJiWd";
export const MOSAppSearchPlaceholderFallback = "RBq2Dc";
export default {SearchDisabledInGroup,GroupsSearchPlaceholder,SearchDisabled,archiveMailboxFoldersSearchPlaceholder,MOSAppSearchPlaceholder,MOSAppSearchPlaceholderFallback};